import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCssVar } from '../../utils';

export interface IInfoMessageProps {
  title?: string;
  message?: string;
  columnSize?: 4 | 6 | 8 | 10 | 12;
  iconSize?: number;
  type?: 'error' | 'success' | 'warning';
  className?: string;
}

export const InfoMessage = ({
  title,
  message,
  columnSize = 4,
  iconSize = 59,
  type = 'warning',
  className = '',
}: IInfoMessageProps) => {
  const iconProps = {
    warning: { icon: faExclamationCircle, color: getCssVar('--yellow-700') },
    success: { icon: faCheckCircle, color: getCssVar('--green-500') },
    error: { icon: faTimesCircle, color: getCssVar('--red-600') },
  };

  return (
    <div className={`columns has-text-centered is-centered ${className}`}>
      <div className={`column is-${columnSize} pt-5 pb-5`}>
        {type === 'warning' ? (
          <svg
            className="has-text-warning mb-4"
            width={iconSize}
            height={iconSize}
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"
            />
          </svg>
        ) : (
          <FontAwesomeIcon
            icon={iconProps[type].icon}
            color={iconProps[type].color}
            data-testid={`${type}-icon`}
            style={{ width: iconSize, height: iconSize }}
            className="mb-4"
          />
        )}
        <h1 className="is-size-5 has-text-weight-bold">{title}</h1>
        <p className="is-size-6">{message}</p>
      </div>
    </div>
  );
};
